import React, { useEffect, useState } from 'react';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Typography from '@visa/vds/typography'
import MCSOverlayLoading from "../../../components/MCSOverlayLoading";
import ServiceAccordion from './ServiceAccordion';
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { EmailNotificationApi } from "../../../services/emailNotification.service";

function ManageEmailNotificationEvents() {
    const { promiseInProgress } = usePromiseTracker();
    const [error, setError] = useState(null);
    const [serviceData, setServiceData] = useState(null);

    const fetchData = async (alertObj) => {
        trackPromise(
            EmailNotificationApi.GetEmailNotificationServices()
                 .then((result) => {
                    const response = result.data;
                    const filteredItems = response.items?.filter(
                        item => item.name?.toUpperCase() !== 'DAF'
                    );
                    const cleanedItems = filteredItems?.map(item => ({
                        ...item,
                        events: Array.isArray(item.events)
                            ? item.events.filter(ev => ev.serviceName?.toUpperCase() !== 'DAF')
                            : item.events
                    }));
                    setServiceData(cleanedItems);
                })
                .catch((error) => {
                    if (alertObj) alertObj.setErrorMessage(error.message);
                    else setError(error);
                })
        );
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Email Notification Management</Typography>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {serviceData && <ServiceAccordion serviceEventData={serviceData} />}
                                </Col>
                            </Row>
                        </Grid>
                    </>
                )}
            </GlobalAlertContext.Consumer>
        </>
    )
}

export default ManageEmailNotificationEvents;